import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import env from '@tencent/vft-common/env';
import { request } from '../request';
import cookie from '../cookie';
import monitor from './monitor';
import * as reporter from './report';
import * as config from './config';
import { getUrlParam } from '../util';
var VAPPID = 11059694;
var VSECRET = 'fdf61a6be0aad57132bc5cdf78ac30145b6cd2c1470b0cfe';
var COOKIE_EXPIRED_TIME = 2592000; // 30天有效期

var CGI = '//access.video.qq.com/user/';
var VIDEO_COOKIE_KEYS = ['main_login', 'vuserid', 'vusession', 'access_token', 'refresh_token', 'openid', 'appid', 'vqq_vuserid', 'vqq_vusession', 'vqq_access_token', 'vqq_openid', 'vqq_appid', 'video_guid', 'video_platform']; // 接口请求次数

export function vRequest(curl) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var url = curl;

  if (!url.match(/^(https?:)?\/\//)) {
    url = CGI + url;
    data = _objectSpread(_objectSpread({}, data), {}, {
      raw: 1,
      vappid: VAPPID,
      vsecret: VSECRET
    });
  }

  return new Promise(function (resolve, reject) {
    var reqTime = +new Date();
    monitor.perf({
      modId: '登录调用量',
      metrics: _defineProperty({}, curl, 1)
    });
    request(url, data, _objectSpread({
      dataType: 'jsonp'
    }, options)).then(function (res) {
      var _metrics2;

      var errmsg = '';
      var errcode = 0;

      if (res && 'errcode' in res && res.errcode !== 0) {
        errcode = res.errcode;
        errmsg = res.errmsg || res.msg;
      } else if ('result' in res && res.result && res.result.code !== 0) {
        errcode = res.result.code;
        errmsg = res.result.msg;
      }

      resolve(res);

      if (errcode !== 0) {
        monitor.fatal({
          modId: curl,
          code: errcode,
          msg: "[".concat(curl, "] ").concat(errmsg || 'unknown', " (").concat(errcode || -1, ")")
        });
      }

      if (!curl.match(/^(https?:)?\/\//)) {
        reporter.report({
          f_event: reporter.EVENT_INIT_REQUEST,
          f_cgi: curl,
          f_cgi_param: JSON.stringify(data),
          f_errcode: errcode,
          f_errmsg: errmsg
        });
      }

      var metricStatus = errcode === 0 ? "".concat(curl, "_succ") : "".concat(curl, "_err");
      monitor.perf({
        modId: '登录调用量',
        metrics: (_metrics2 = {}, _defineProperty(_metrics2, metricStatus, 1), _defineProperty(_metrics2, "".concat(curl, "_time"), +new Date() - reqTime), _metrics2),
        tags: {
          loginType: loginType(),
          errcode: errcode
        }
      });
    }).catch(function (e) {
      var _metrics3;

      reject(e);
      monitor.fatal({
        modId: curl,
        code: -1,
        msg: "[".concat(curl, "] network error (-1)")
      });
      monitor.perf({
        modId: '登录调用量',
        metrics: (_metrics3 = {}, _defineProperty(_metrics3, "".concat(curl, "_err"), 1), _defineProperty(_metrics3, "".concat(curl, "_time"), +new Date() - reqTime), _metrics3),
        tags: {
          loginType: loginType(),
          errcode: -1
        }
      });
    });
  });
}
/**
 * 获取登录态类型
 */

export function loginType() {
  var loginType = cookie.get('main_login');

  if (!loginType && getUin() && getSkey()) {
    return 'qq';
  }

  return loginType || '';
}
export function getDomain() {
  var domain = '';

  if (location.host.match(/(film|v)\.qq\.com/)) {
    var arr = location.host.split('.');
    var len = arr.length;

    if (len > 3) {
      domain = arr.slice(len - 3, len).join('.');
    } else {
      domain = location.host;
    }
  }

  return domain;
}
/**
 * 同步登录态
 */

export function syncCookies(callback) {
  _loadVideoCookie(function (vcookie) {
    if (vcookie) {
      var cookies = vcookie.getCookie(); // checkSameCookies()

      if (!env.isApp) {
        var cookieDomain = getDomain();
        var preType = cookies.main_login === 'qq' ? 'wx' : 'qq';

        if (cookie.get("".concat(preType, "_nick")) || cookie.get("".concat(preType, "_head"))) {
          cookie.remove("".concat(preType, "_nick"), {
            domain: cookieDomain,
            path: '/'
          });
          cookie.remove("".concat(preType, "_head"), {
            domain: cookieDomain,
            path: '/'
          });
        } // 同步 cookie


        VIDEO_COOKIE_KEYS.forEach(function (key) {
          // fix: 以前的逻辑 cookie 是种在当前域，需要先移出当前域名的 cookie 信息，再同步
          // 新逻辑 cookie 种在三级域名，如 m.v.qq.com，cookie 种在 v.qq.com
          if (cookieDomain !== location.host) {
            cookie.remove(key, {
              domain: location.host
            });
          }

          cookie.set(key, cookies[key] || '', {
            expires: cookies[key] ? COOKIE_EXPIRED_TIME : -24,
            domain: cookieDomain,
            path: '/'
          });
        });
      }

      callback && callback(cookies);
    } else {
      callback && callback(null);
    }
  });

  reporter.report({
    f_event: reporter.EVENT_INIT_SYNC
  });
}
/**
 * 检查 cookie 异常情况，重复数据或者数据不一致
 */

function checkSameCookies() {
  try {
    var _cookies = document.cookie.split(/;\s?/);

    var dupCookie = {};
    var isCookieDups = false;
    var isCookieNotMatch = false;

    _cookies.forEach(function (str) {
      var reg = str.match(new RegExp('^(appid|openid|main_login|(vqq_)?vuserid|(vqq_)?vusession)='));
      var matchKey = reg && reg[1] ? reg[1] : '';

      if (matchKey) {
        if (!dupCookie[matchKey]) {
          dupCookie[matchKey] = {
            dup: 0,
            str: str
          };
        }

        dupCookie[matchKey].dup++;

        if (dupCookie[matchKey].dup > 1) {
          // cookie 污染
          isCookieDups = true;
        }

        if (dupCookie[matchKey].str && dupCookie[matchKey].str !== str) {
          isCookieNotMatch = true;
        }
      }
    });

    if (isCookieDups || isCookieNotMatch) {
      monitor.fatal({
        modId: 'cookie_err',
        code: 777,
        operate: "".concat(loginType(), "_cookie_").concat(isCookieDups ? 'dup' : 'dif'),
        msg: "[".concat(loginType(), "_cookie_").concat(isCookieDups ? 'dup' : 'dif', "] ").concat(document.cookie)
      });
    }
  } catch (e) {}
}

export function _loadVideoCookie(callback) {
  if (window.txvCookie) {
    // 避免重复加载 cookie 页面
    return callback && callback(window.txvCookie);
  }

  var getcookieFrame = 'tvv_login_cookie_cross_domin_frame';
  var target = document.getElementById(getcookieFrame); // 防止cookie超时没返回

  var timer = setTimeout(function () {
    callback && callback(window.txvCookie || null);
    reporter.report({
      f_event: reporter.EVENT_INIT_COOKIE_TIMEOUT
    });
  }, 3000);

  if (!target) {
    // 同步 cookie 接收的回调方法
    window.loadVideoCookie = function (videoCookie) {
      callback && callback(videoCookie);
      window.txvCookie = videoCookie;
      clearTimeout(timer);
      reporter.report({
        f_event: reporter.EVENT_INIT_COOKIE_LOADED
      });
    };

    var $iframe = document.createElement('iframe');
    $iframe.src = '//video.qq.com/getcookie/cookie.html';
    $iframe.id = getcookieFrame;
    $iframe.style.display = 'none';

    $iframe.onload = function () {
      clearTimeout(timer);
      reporter.report({
        f_event: reporter.EVENT_INIT_COOKIE_ONLOAD
      });
    };

    document.body.appendChild($iframe);
  }

  reporter.report({
    f_event: reporter.EVENT_INIT_GETCOOKIE
  });
}
/**
 * 续期登录态
 */

var _refreshTime = 0;
var _maxRefreshTime = 2;
export function refreshAuthToken(callback) {
  // TV登录态不过续期
  var appid = cookie.get('vqq_appid') || cookie.get('appid');

  if (config.TV_APPIDS.indexOf(appid) > -1) {
    return callback();
  }

  var type = loginType() || 'qq';
  var csrfParam = buildCSRF();
  vRequest('auth_refresh', _objectSpread({
    type: type
  }, csrfParam), {
    timeout: 1500
  }).then(function (data) {
    if (data && data.errcode === 0) {
      var cookieDomain = getDomain();
      var cookieOption = {
        expires: COOKIE_EXPIRED_TIME,
        domain: cookieDomain,
        path: '/'
      };

      if (type === 'qq' && cookie.get('vqq_appid') && cookie.get('vqq_openid')) {
        var PREFIX = type === 'qq' ? 'vqq_' : '';

        for (var key in data) {
          if (VIDEO_COOKIE_KEYS.indexOf(key) > -1) {
            cookie.set(PREFIX + key, data[key] || '', {
              expires: data[key] ? COOKIE_EXPIRED_TIME : -24,
              domain: cookieDomain,
              path: '/'
            });
          }
        }
      } else {
        cookie.set('vuserid', data.vuserid, cookieOption);
        cookie.set('vusession', data.vusession, cookieOption);
      }

      cookie.set("".concat(type, "_nick"), data.nick, cookieOption);
      cookie.set("".concat(type, "_head"), data.head, cookieOption);
      cookie.set('last_refresh_time', +new Date(), cookieOption);
      cookie.set('last_refresh_vuserid', data.vuserid, cookieOption);
      updateAuthRefreshTimer(data.next_refresh_time);
      callback && callback();
    } else {
      if (data && [-1001, -1002, -1003, -1004, 1006, 1111, 1112].indexOf(data.errcode) > -1) {
        clearCookie(callback);
      } else {
        if (_refreshTime < _maxRefreshTime) {
          refreshAuthToken(callback);
        } else {
          callback && callback();
        }

        _refreshTime++;
      }
    }
  }).catch(function (e) {
    if (_refreshTime < _maxRefreshTime) {
      refreshAuthToken(callback);
    } else {
      callback && callback();
    }

    _refreshTime++;
  });
}
/**
 * 续期定时器
 * @param {Number} nextTime 下次续期时间/s
 */

var _refreshTimer = null;

function updateAuthRefreshTimer() {
  var nextTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  if (_refreshTimer) clearTimeout(_refreshTimer);

  if (nextTime > 0) {
    _refreshTimer = setTimeout(function () {
      refreshAuthToken();
      clearTimeout(_refreshTimer);
    }, nextTime * 1000);
  }
}
/**
 * PTLogin 登录态换视频票据
 */


var _authLoginRetryTime = 0;
export function skey2Vusession(callback) {
  var csrfParam = buildCSRF();
  vRequest('auth_login', _objectSpread({
    type: 'qq',
    login_flag: 1
  }, csrfParam), {
    timeout: 3000
  }).then(function (res) {
    if (res && res.errcode === 0) {
      var options = {
        expires: COOKIE_EXPIRED_TIME,
        domain: getDomain(),
        path: '/'
      };
      cookie.set("qq_nick", res.nick, options);
      cookie.set("qq_head", res.head, options);
      cookie.set('last_refresh_time', +new Date(), options);
      cookie.set('last_refresh_vuserid', res.vuserid, options);
      cookie.set('vuserid', res.vuserid, options);
      cookie.set('vusession', res.vusession, options);
      cookie.set('main_login', 'qq', options);
      callback();
    } else if (res && [1006, 1111, 1112].indexOf(res.errcode) > -1) {
      // 票据过期，或者无效票据需要清掉 cookie 信息
      clearCookie(callback);
    } else {
      if (_authLoginRetryTime < _maxRefreshTime) {
        skey2Vusession(callback);
      } else {
        callback && callback();
      }

      _authLoginRetryTime++;
    }
  }).catch(function () {
    if (_authLoginRetryTime < _maxRefreshTime) {
      skey2Vusession(callback);
    } else {
      callback && callback();
    }

    _authLoginRetryTime++;
  });
  reporter.report({
    f_event: reporter.EVENT_INIT_LOGIN
  });
}
var retryTime = 0;
export function innerToken2tenvideo(callback) {
  var loginType = '';
  var isMsdk = getUrlParam('msdkEncodeParam').length > 0;
  var data = {};

  if (isMsdk) {
    data = {
      appid: getUrlParam('appid'),
      openid: getUrlParam('openid'),
      algorithm: getUrlParam('algorithm'),
      version: getUrlParam('version'),
      timestamp: +getUrlParam('timestamp'),
      sig: getUrlParam('sig'),
      encode: 2,
      msdkEncodeParam: getUrlParam('msdkEncodeParam')
    };
    loginType = data.appid.match(/^[0-9]+$/) ? 'qq' : 'wx';
  } else if (env.isWeishi) {
    loginType = cookie.get('iAuthType') == 1 ? 'qq' : 'wx';
  }

  if (!loginType) {
    // 未登录
    return callback();
  }

  clearCookie(function () {
    if (env.isWeishi && loginType === 'qq' && cookie.get('sSessionKey')) {
      cookie.set('accessToken', cookie.get('sSessionKey'), {
        domain: '.qq.com',
        path: '/'
      });
    }

    var type = isMsdk ? 3 : loginType == 'qq' ? 1 : 2; // type: 2 // 1|非游戏QQ互联，2|非游戏微信，3|游戏msdk

    request("//vip.video.qq.com/fcgi-bin/comm_cgi?name=third_login&otype=xjson&type=".concat(type), JSON.stringify(data), {
      type: 'post',
      dataType: 'json',
      xhrFields: {
        withCredentials: true
      },
      timeout: 2000
    }).then(function (res) {
      var options = {
        expires: COOKIE_EXPIRED_TIME,
        path: '/'
      };
      cookie.set("".concat(loginType, "_nick"), encodeURIComponent(res.nick), options);
      cookie.set("".concat(loginType, "_head"), encodeURIComponent(res.head), options);
      callback();
    }).catch(function (e) {
      console.error('innerToken2tenvideo caught error', e);

      if (retryTime < 1) {
        innerToken2tenvideo(callback);
        retryTime++;
      } else {
        callback();
      }

      monitor.fatal({
        modId: 'third_login',
        code: e && e.ret ? e.ret : -1,
        msg: "third_login caught error (".concat(e, ")")
      });
    });
  });
}
/**
 * 清除登录态
 * @param {String} [type] 账号类型
 * @param {Function} callback 回调
 */

export function clearCookie(type, callback) {
  var cookies = [];

  if (typeof type === 'function') {
    callback = type;
    type = loginType() || 'qq';
  }

  if (type === 'wx') {
    cookies = config.WXLOGIN_COOKIE;
  } else {
    cookies = config.QQLOGIN_COOKIE.concat(config.PTLOGIN_COOKIE);
  }

  var domain = getDomain();
  cookies = cookies.concat(config.VIDEO_COOKIE);
  cookies.forEach(function (key) {
    cookie.remove(key, {
      domain: domain,
      path: '/'
    });
  });

  if (cookie.get('uin') || cookie.get('luin')) {
    config.PTLOGIN_COOKIE.forEach(function (key) {
      cookie.remove(key, {
        domain: 'qq.com',
        path: '/'
      });
    });
  } // 清除上次续期的时间


  cookie.remove('last_refresh_time', {
    domain: domain,
    path: '/'
  });
  cookie.remove('last_refresh_vuserid', {
    domain: domain,
    path: '/'
  });
  var params = {
    type: type
  };

  if (type === 'qq' && cookie.get('appid')) {
    // 同时存在QQ和微信登录时，由于原先V站切互联时遇到一些未明原因的问题，juliehwang 在清QQ登录态时，把微信的 appid 也清了
    // 现在增加参数来确保不清微信的 appid
    params.keepwx = 1;
  }

  vRequest('auth_logout', params, {
    timeout: 10000
  }).then(callback).catch(callback);
}
/**
 * 根据登录态生成 gtk 加密串，用于校验视频票据
 * @return {Object}
 * @property {string} g_tk skey 票据.
 * @property {string} g_vstk 互联和微信 vusession 票据.
 * @property {string} g_actk 互联和微信 access_token 票据.
 */

export function buildCSRF() {
  var params = {};
  var type = loginType();

  if (type === 'qq') {
    var skey = getSkey();

    if (skey) {
      params.g_tk = time33(skey);
    }

    var vs = cookie.get('vqq_vusession');

    if (vs) {
      params.g_vstk = time33(vs);
    }

    var ac = cookie.get('vqq_access_token');

    if (ac) {
      params.g_actk = time33(ac);
    }
  } else if (type === 'wx') {
    var _vs = cookie.get('vusession');

    if (_vs) {
      params.g_vstk = time33(_vs);
    }

    var _ac = cookie.get('access_token');

    if (_ac) {
      params.g_actk = time33(_ac);
    }
  }

  return params;
}
/**
 * 获取QQ号
 * @returns {number}
 */

export function getUin() {
  if (getSkey() === '') {
    return 0;
  }

  var uin = parseInt(cookie.get('uin').replace(/^o0*/g, ''), 10);

  if (!uin || uin <= 10000) {
    uin = parseInt(cookie.get('luin').replace(/^o0*/g, ''), 10);

    if (!uin || uin <= 10000) {
      return 0;
    }
  }

  return uin;
}
/**
 * 获取 skey
 * @returns {string} skey
 */

export function getSkey() {
  var skey = cookie.get('skey') || cookie.get('lskey');
  return skey ? skey.trim() : '';
}
/**
 * 获取 PTLogin token
 * @returns {string}
 */

export function getToken() {
  var skey = getSkey();
  return skey ? time33(skey) : '';
}
/**
 * 哈希time33算法
 */

export function time33(skey) {
  var hash = 5381;

  for (var i = 0, len = skey.length; i < len; ++i) {
    hash += (hash << 5) + skey.charAt(i).charCodeAt();
  }

  return hash & 0x7fffffff;
}